import { useQuery } from '@tanstack/vue-query'
import { queryKeys } from '~/queryClient'
import financialBff from '~/services-v2/financial-bff/financial-bff'

export default function useAccessUserCredentials(brand: Ref<string | undefined | null>, enabled: Ref<boolean> | boolean = true) {
  const queryKey = queryKeys.INSTALLATION.ACCESS_USER_CREDENTIALS(brand)

  const queryFn = async () => {
    if (!brand.value) {
      throw new Error('Brand is required')
    }

    const res = await financialBff('query')({
      access_user_credentials: [
        { brand: brand.value },
        {
          success: true,
          message: true,
          data: {
            access_user: true,
            platform: true,
            partner_id: true,
          },
        },
      ],
    })

    return res.access_user_credentials
  }

  return useQuery({
    queryKey,
    queryFn,
    enabled,
  })
}
